import './../scss/styles.scss';

import './lib/templates.js';
import './lib/main.js';
import {fetchBitmaps} from "./lib/bitmaps";

// Initialize window.bitmapData for storing bitmap references
window.bitmapData = {};

// Start with page 1
await fetchBitmaps(1);
